import { ArrowUpIcon, CheckCircleIcon, ChevronLeftIcon, ChevronRightIcon } from "vue-feather-icons";

import Navbar from "@/components/navbar";
import Footer from "@/components/footer";

import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";

import axios from "axios";

/**
 * Shop checkouts component
 */
export default {
    data() {
        return {
            number: 0,
            concurrent1: '<50',
            concurrent2: '<100',
            concurrent3: '<250',
            concurrent4: '<2,500',
            concurrent5: '<5,000',
            concurrent6: '>5,000',
            totalCalculator: 0,
            perDay: 0,
            perUserDay: 0,

            dataUploadValue: 50,
            timeUseValue: 1,
            liveValue: 1,
            userAccountValue: 50,
            // storageValue: 50,



            dataUploadPrice: 0,
            timeUsePrice: 0,
            livePrice: 0,
            userAccountPrice: 0,
            // storagePrice: 0,


            processStyle: {
                backgroundColor: "#00c9a7",
            },
            tooltipStyle: {
                backgroundColor: "#00c9a7",
            },
        };
    },
    components: {
        Navbar,
        Footer,
        ArrowUpIcon,
        VueRangeSlider,
        CheckCircleIcon,
        ChevronLeftIcon,
        ChevronRightIcon
    },
    computed: {
        totalValue() {
            return (
                parseInt(this.dataUploadPrice) +
                parseInt(this.timeUsePrice) +
                parseInt(this.livePrice) +
                parseInt(this.userAccountPrice)
                // parseInt(this.storagePrice) +

            );
        },
    },
    mounted() {
        this.dataUploadValue = this.$route.query.user || 50; //data upload
        this.timeUseValue = this.$route.query.user || 1; //time use
        this.liveValue = this.$route.query.live || 1; //live
        this.userAccountValue = this.$route.query.user || 50; //concurrent
        this.priceCalCulator();

        // this.storageValue = this.$route.query.storage || 50;
        // this.updatePricing();
    },
    methods: {
        async priceCalCulator() {
            console.log(this.dataUploadValue)
            let initialParam = {
                uploadTHB: 1.20,
                timeMonth: 30,
                timeTHB: 0.133,
                liveMinute: 60,
                liveTHB: 1.65

            };

            let calPoint = 0;
            switch (this.userAccountValue) {
                case this.userAccountValue <= 50:
                    calPoint = 0;
                    break;
                case this.userAccountValue > 50 && this.userAccountValue <= 75:
                    calPoint = 300;
                    break;
                case this.userAccountValue > 75 && this.userAccountValue <= 100:
                    calPoint = 500;
                    break;
                case this.userAccountValue > 100 && this.userAccountValue <= 250:
                    calPoint = 1000;
                    break;
                case this.userAccountValue > 250 && this.userAccountValue <= 2500:
                    calPoint = 1500;
                    break;
                case this.userAccountValue > 2500 && this.userAccountValue <= 5000:
                    calPoint = 2500;
                    break;
            };
            let calUpload = this.dataUploadValue * initialParam.uploadTHB;
            let calTimeUse = (this.timeUseValue * initialParam.timeMonth) * initialParam.timeTHB;
            let calLive = (this.liveValue * initialParam.liveMinute) * initialParam.liveTHB;
            let summary = calUpload + calTimeUse + calLive + calPoint;
            this.totalCalculator = summary.toFixed(2);
            this.perDay = (summary / 30).toFixed(2);
            // this.perUserDay = (summary / this.userAccountValue).toFixed(2);
        },
        async updatePricing() {
            let pricing = await this.calculatePricing();

            let data = pricing.data.result;

            this.dataUploadPrice = data.user;
            this.timeUsePrice = data.user;
            this.livePrice = data.live;
            this.userAccountPrice = data.user;
            // this.storagePrice = data.storage;
        },
        // async calculatePricing() {
        //     return await axios.get(
        //         `/company/calculate?user=` +
        //         this.userAccountValue +
        //         `&storage=` +
        //         this.storageValue +
        //         `&live=` +
        //         this.liveValue
        //     );
        // },
    },
}